.card {
  display: block;
  padding: 16px 24px;
  border-top: 0.5px solid var(--colors-grays-light);
  width: 100%;
  transition: background-color 0.15s ease;
}

.card:hover,
.card:focus-within {
  background-color: var(--colors-grays-ultralight);
}

.badgesContainer {
  z-index: 1;
}

.badgesContainer:has(> :only-child) {
  justify-content: flex-end;
}

.specialBadge {
  text-align: center;
  border-radius: 16px;
  max-width: 50px;
  height: 24px;
  padding: 0 8px;
  white-space: nowrap;
  background-color: var(--colors-info-main);
  color: var(--colors-text-info);
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
}

.mark {
  font-weight: var(--font-weight-semibold);
  background-color: transparent;
}

.name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.searchLink {
  display: block;
  width: 100%;
  padding: 20px 24px;
  transition: background-color 0.15s ease;
}

.searchLink:hover,
.searchLink:focus-within {
  background-color: var(--colors-grays-ultralight);
}

.loading {
  position: relative;
  margin-top: 8px;
  bottom: 0px;
  left: 0;
  right: 0;
}
